import { DevicesOther, LocalMall, SimCard } from "@mui/icons-material";
import BulkSMS from "@src/domain/bulkSMS/BulkSMS";
import Codes from "@src/domain/codes/Codes";
import Dashboard from "@src/domain/dashboard/Dashboard";
import Devices from "@src/domain/devices/Devices";
import Firmware from "@src/domain/firmware/Firmware";
import Packages from "@src/domain/packages/Packages";
import Purchases from "@src/domain/purchases/Purchases";
import TrapAlarm from "@src/domain/trapAlarms/TrapAlarm";
import { urls } from "@src/domain/urls";
import Users from "@src/domain/users/Users";
import Code from "@src/icons/Code";
import DashboardIcon from "@src/icons/Dashboard";
import Outgoing from "@src/icons/Outgoing";
import Package from "@src/icons/Package";
import User from "@src/icons/User";
import { FormattedMessage } from "react-intl";

import { type PageInterface } from "./page.interface";

export const pages: PageInterface[] = [
    {
        routeProps: {
            path: urls.dashboard,
            component: Dashboard,
            exact: true,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.dashboard" defaultMessage="Dashboard" />,
            icon: <DashboardIcon />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.users,
            component: Users,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.users" defaultMessage="Kunden" />,
            icon: <User />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.devices,
            component: Devices,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.devices" defaultMessage="Geräte" />,
            icon: <DevicesOther />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.trapAlarms,
            component: TrapAlarm,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.trapAlarm" defaultMessage="Fallenalarme" />,
            icon: <DevicesOther />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.packages,
            component: Packages,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.packages" defaultMessage="Pakete / Abos" />,
            icon: <Package />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.purchases,
            component: Purchases,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.purchases" defaultMessage="Lizenzverlängerungen" />,
            icon: <LocalMall />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.codes,
            component: Codes,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.codes" defaultMessage="Codes" />,
            icon: <Code />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.bulkSMS,
            component: BulkSMS,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.bulkSMS" defaultMessage="Massen-SMS" />,
            icon: <Outgoing />,
        },
        roles: ["admin"],
    },
    {
        routeProps: {
            path: urls.firmware,
            component: Firmware,
        },
        menuProps: {
            text: <FormattedMessage id="reviermanager.page.firmware" defaultMessage="Firmware" />,
            icon: <SimCard />,
        },
        roles: ["admin"],
    },
];
